import { isEmpty } from 'lodash';

import {
  INCOME_RULE_ID,
  RULE_CATEGORY_ID,
  RULE_ID,
  RULE_SUB_CATEGORY_ID,
} from '~/common/constants';
import type { GutterItem } from '~/types';

const IncomePagesWithUnderwriterCheckbox = [
  INCOME_RULE_ID.INCOME_REVIEW_BREAKDOWN_RULE_ID,
  INCOME_RULE_ID.RENTAL_INCOME_CALCULATION_RULE_ID,
  INCOME_RULE_ID.REVIEW_BREAKDOWN_YAML_RULE_ID,
];

const PropertyPagesWithUnderwriterCheckbox = new Set([
  RULE_ID.CPL_REVIEW_RULE,
  RULE_ID.WIRE_INSTRUCTIONS_RULE,
  RULE_ID.TITLE_COMMITMENT_RULE,
  RULE_ID.PURCHASE_AGREEMENT_RULE_ID,
  RULE_ID.SELLER_ACQUISITION_RULE,
  RULE_ID.TAX_BREAKDOWN_RULE_ID,
  RULE_ID.TAX_BREAKDOWN_NO_DOCS_RULE_ID,
]);

export const isVisible = (
  isUnderwriter?: boolean,
  selectedAlert?: GutterItem,
  isLoanSubmitted?: boolean,
  isZappedLoan?: boolean,
  hasAccessToUnderwriterView?: boolean,
): boolean => {
  const isUnderwriterCheckboxVisible =
    selectedAlert?.isUnderwriterCheckboxVisible;

  const isPropertyPageWithCheckbox = PropertyPagesWithUnderwriterCheckbox.has(
    selectedAlert?.ruleId,
  );

  const shouldDisplayUnderwriterCheckboxOnProperty =
    isPropertyPageWithCheckbox && isUnderwriterCheckboxVisible && isUnderwriter;

  if (shouldDisplayUnderwriterCheckboxOnProperty) {
    return true;
  }

  if (
    selectedAlert?.ruleId === RULE_ID.TAX_BREAKDOWN_RULE_ID ||
    selectedAlert?.ruleId === RULE_ID.TAX_BREAKDOWN_NO_DOCS_RULE_ID
  ) {
    return (
      (hasAccessToUnderwriterView && isUnderwriterCheckboxVisible) ?? false
    );
  }

  if (
    selectedAlert?.ruleSubCategoryId === RULE_SUB_CATEGORY_ID.UNDERWRITER_FHA
  ) {
    return false;
  }

  const isZappedLoanNonUnderwriterNonBolt =
    isEmpty(selectedAlert) ||
    !isUnderwriter ||
    !isLoanSubmitted ||
    isZappedLoan;
  if (isZappedLoanNonUnderwriterNonBolt) return false;

  if (
    (selectedAlert?.ruleCategoryId === RULE_CATEGORY_ID.INCOME &&
      !selectedAlert.ruleResultId &&
      IncomePagesWithUnderwriterCheckbox.every(
        (pageId) => pageId !== selectedAlert?.ruleId,
      )) ||
    isUnderwriterCheckboxVisible === false
  )
    return false;
  if (
    !isUnderwriterCheckboxVisible &&
    selectedAlert?.ruleCategoryId !== RULE_CATEGORY_ID.INCOME
  )
    return false;

  return true;
};

export const determineAutoCheck = (
  isZapped: boolean,
  shouldAutoCheck = false,
  ruleId?: number,
) => {
  if (PropertyPagesWithUnderwriterCheckbox.has(ruleId)) {
    return false;
  }

  return isZapped || shouldAutoCheck;
};
